import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconNightSleetShower: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M15.188 44.8668C11.6769 38.9113 10.2991 31.7113 11.8102 24.4224C14.788 9.84462 28.2547 0.155726 42.7435 1.48906C43.8102 1.57795 44.8324 1.75573 45.8991 1.9335C47.0546 2.20017 48.1658 2.51128 49.2769 2.86684C47.3658 3.75573 45.5435 4.82239 43.9435 6.15573C39.6769 9.57795 36.5213 14.4224 35.3658 20.2002C34.8769 22.5557 34.7435 24.9113 34.9213 27.1779C33.0546 29.1779 31.4991 31.5335 30.4324 34.1113C23.7213 34.9557 18.0324 39.0891 15.188 44.8668Z"
        fill="#D2D4DA"
      />
      <path
        d="M78.6555 48.2448H73.5888V43.3115C73.5888 32.4226 64.4777 23.5781 53.2333 23.5781C45.9888 23.5781 39.6777 27.3115 36.1222 32.867C35.0111 34.5559 34.1666 36.4226 33.6333 38.3781H32.9222C25.9444 38.3781 20.0333 42.9559 18.3 49.1781C17.9 50.467 17.6777 51.8003 17.6777 53.1781C17.6777 61.3559 24.5222 68.0226 32.9222 68.0226H78.6555C84.2555 68.0226 88.7889 63.5781 88.7889 58.1559C88.7889 52.6892 84.2555 48.2448 78.6555 48.2448Z"
        fill="#87D6F8"
      />
      <path
        d="M73.2763 79.8002L75.854 83.3557L73.1429 85.3113L70.5651 81.7557L68.0318 85.3113L65.3207 83.3557L67.8985 79.8002L63.7207 78.4668L64.7429 75.3113L68.9207 76.6446V72.2891H72.254V76.6446L76.4318 75.3113L77.454 78.4668L73.2763 79.8002Z"
        fill="#D2E0FF"
      />
      <path
        d="M67.5215 88.6223L63.366 89.9668V85.6001H60.0326V89.9668L55.8771 88.6223L54.8438 91.789L58.9993 93.1445L56.4326 96.6779L59.1326 98.6334L61.6993 95.1001L64.266 98.6334L66.966 96.6779L64.3993 93.1445L68.5549 91.789L67.5215 88.6223Z"
        fill="#D2E0FF"
      />
      <path
        d="M60.8778 72.4224V72.4668L56.0334 85.7557H51.3223L56.1667 72.4668V72.4224H60.8778Z"
        fill="#87D6F8"
      />
      <path
        d="M41.5431 72.4224V72.4668L39.8986 76.8224H35.1875L36.7875 72.4668V72.4224H41.5431Z"
        fill="#87D6F8"
      />
      <path
        d="M51.1881 72.4224V72.4668L49.5881 76.8224H44.877L46.477 72.4668V72.4224H51.1881Z"
        fill="#87D6F8"
      />
      <path
        d="M43.2439 81.3115L41.6328 85.7449H46.3661L47.9773 81.3115H43.2439Z"
        fill="#87D6F8"
      />
    </svg>
  )
}

export default WeatherIconNightSleetShower
